import { useQuery } from '@tanstack/react-query'

import { api } from '../../../services/api'
import { queriesKeys } from '../queriesKeys'

export const useGetEarningsLetter = () =>
  useQuery({
    queryFn: () => api.earnings.getEarningsLetter(),
    queryKey: queriesKeys.earnings.getEarningsLetter(),
  })
